import classnames from "classnames";
import debounce from "lodash/debounce";
import { useCallback, useContext, useEffect, useState } from "react";
import Button from "./../Button";

import ActiveComponentContext from "../../contexts/ActiveComponentContext";

import "./changePageButtons.scss";

const ChangePageButtons = () => {
  const { active: activeComponent } = useContext(ActiveComponentContext);
  const [visible, setVisible] = useState(false);
  const [previousActiveComponent, setPreviousActiveComponent] =
    useState(activeComponent);
  const heightOffset = window.innerHeight / 2;

  const scrollHandler = useCallback(() => {
    if (!visible && window.scrollY >= heightOffset) {
      setVisible(true);
    } else if (visible && window.scrollY < heightOffset) {
      setVisible(false);
    }
  }, [visible, setVisible, heightOffset]);

  const scrollTo = debounce((href, direction) => {
    const id = href || previousActiveComponent;
    const currentElement = document.querySelector(`#${id}`);
    const element = currentElement?.[`${direction}Sibling`];
    const offset = id === "Disclosures" ? 166 : 0;
    if (element) {
      window.scrollTo({
        top: element.offsetTop - offset,
        behavior: "smooth",
      });
    }
  }, 200);

  useEffect(() => {
    if (activeComponent !== "" && activeComponent !== previousActiveComponent) {
      setPreviousActiveComponent(activeComponent);
    }
  }, [activeComponent, previousActiveComponent]);

  useEffect(() => {
    window.addEventListener("scroll", scrollHandler);

    return () => window.removeEventListener("scroll", scrollHandler);
  }, [scrollHandler]);

  return (
    <div
      className={classnames("change-page-buttons", { "is-visible": visible })}
    >
      <div className="change-page-buttons__previous">
        <div className="change-page-buttons__label">Previous</div>
        <Button
          className={classnames(
            "change-page-buttons__btn",
            "change-page-buttons__btn-next"
          )}
          variant="outline"
          size="large"
          iconName="system-chevron-up-large"
          iconSize="medium"
          aria-label="Go to Previous Page"
          onClick={() => scrollTo(activeComponent, "previous")}
        />
      </div>
      <div className="change-page-buttons__next">
        <Button
          className={classnames(
            "change-page-buttons__btn",
            "change-page-buttons__btn-prev"
          )}
          variant="outline"
          size="large"
          iconName="system-chevron-down-large"
          iconSize="medium"
          aria-label="Go to Next Page"
          onClick={() => scrollTo(activeComponent, "next")}
        />
        <div className="change-page-buttons__label">Next</div>
      </div>
    </div>
  );
};

export default ChangePageButtons;
